import useSelectedAccountControllerState from './useSelectedAccountControllerState'

export default useSelectedAccountControllerState
